/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface InboxArchiveAllResponse
 */
export interface InboxArchiveAllResponse {
    /**
     * Inbox notifications created at or before this time are being archived
     */
    archived_before: Date;
}

/**
 * Check if a given object implements the InboxArchiveAllResponse interface.
 */
export function instanceOfInboxArchiveAllResponse(value: object): value is InboxArchiveAllResponse {
    if (!('archived_before' in value) || value['archived_before'] === undefined) return false;
    return true;
}

export function InboxArchiveAllResponseFromJSON(json: any): InboxArchiveAllResponse {
    return InboxArchiveAllResponseFromJSONTyped(json, false);
}

export function InboxArchiveAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboxArchiveAllResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'archived_before': (json['archived_before'] == null ? json['archived_before'] : parseDateTime(json['archived_before'])),
    };
}

export function InboxArchiveAllResponseToJSON(json: any): InboxArchiveAllResponse {
    return InboxArchiveAllResponseToJSONTyped(json, false);
}

export function InboxArchiveAllResponseToJSONTyped(value?: InboxArchiveAllResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'archived_before': value['archived_before'] == null ? value['archived_before'] : serializeDateTime(value['archived_before']),
    };
}

